import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonPlatformService, Platform } from 'psd-common';

@Component({
    selector: 'central-login-background-slider',
    templateUrl: 'central-login-background-slider.component.html'
})
export class CentralLoginBackgroundSliderComponent implements OnChanges {
    @Input('platform') platform: Platform;

    public platformPrefix: string;
    public slides: any;
    public backgrounds: Array<string> = [];
    public currentSlide: number = 0;

    private slideInterval: number = 6000;

    constructor(private platformService: CommonPlatformService, private route: ActivatedRoute) {}

    ngOnChanges(changes: SimpleChanges) {
        if(changes['platform'].currentValue) {
            if (this.platform.apiUrl) {
                this.initBackgrounds();
            } else {
                this.backgrounds.push(`assets/img/background-login.png`);
            }
        } else {
            this.backgrounds.push(`assets/img/background-login.png`);
        }
    }

    initBackgrounds() {
        this.platformService.getPlatformLoginBackgrounds(this.platform.apiUrl).subscribe(_result => {
            this.backgrounds = this.convertBackgroundURLtoStyleProp(_result);

            if (this.backgrounds.length > 1) {
                this.currentSlide = 0;
                setInterval(() => {
                    this.nextSlide();
                }, this.slideInterval);
            }
        });
    }

    convertBackgroundURLtoStyleProp(backgrounds: Array<string>): Array<string> {
        let _backgrounds = [];

        if (backgrounds.length > 0) {
            for (let background of backgrounds) {
                _backgrounds.push(background);
            }
        } else {
            _backgrounds.push(`assets/img/background-login.png`);
        }

        return _backgrounds;
    }

    nextSlide() {
        let numberOfBackgrounds: number = this.backgrounds.length;
        if (numberOfBackgrounds > 1) {
            if (numberOfBackgrounds != this.currentSlide + 1) {
                this.currentSlide++;
            } else {
                this.currentSlide = 0;
            }
        }
    }

    safeUrl(url) {
        return `url('${url}')`;
    }
}